import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxLoadingModule } from "ngx-loading";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatRadioModule } from "@angular/material/radio";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { GuardServiceTableComponent } from "./guard-service-table/guard-service-table.component";
import { GuardScheduleEditorComponent } from "./guard-schedule-editor/guard-schedule-editor.component";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { ShiftDetailFormRowComponent } from "./guard-schedule-editor/shift-detail-form-row/shift-detail-form-row.component";
import { MatIconModule } from "@angular/material/icon";
import { SiteSelectorTableModule } from "../sites/site-selector-table/site-selector-table.module";

@NgModule({
  declarations: [
    GuardServiceTableComponent,
    GuardScheduleEditorComponent,
    ShiftDetailFormRowComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxLoadingModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatIconModule,
    SiteSelectorTableModule,
  ],
  exports: [
    GuardServiceTableComponent,
    GuardScheduleEditorComponent,
    ShiftDetailFormRowComponent,
  ],
  providers: [
    // GuardManagementService // omitted since it's provided in 'root' as a singleton. please update this if that changes.
  ],
})
export class GuardManagementModule {}
